// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg version=%271.1%27 id=%27Layer_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%27512px%27 height=%27512px%27 viewBox=%270 0 32 32%27 style=%27enable-background:new 0 0 512 512;%27 xml:space=%27preserve%27%3e%3cpath d=%27M448,71.9c-17.3-13.4-41.5-9.3-54.1,9.1L214,344.2l-99.1-107.3c-14.6-16.6-39.1-17.4-54.7-1.8 c-15.6,15.5-16.4,41.6-1.7,58.1c0,0,120.4,133.6,137.7,147c17.3,13.4,41.5,9.3,54.1-9.1l206.3-301.7 C469.2,110.9,465.3,85.2,448,71.9z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 800px) {
	body,
	#main-container {
		overflow-x: hidden;
	}
}

@media (max-width: 1400px) {
	.remove-below-1400 {
		display: none !important;
	}
}

@media (max-width: 1200px) {
	.remove-below-1200 {
		display: none !important;
	}
}
@media (max-width: 1000px) {
	.remove-below-1000 {
		display: none !important;
	}
}

body {
	overflow-y: hidden;
}

#main-container {
	box-sizing: border-box;
	position: relative;
	overflow-y: auto;
	height: 100vh;
	padding-top: 0.25em;
	display: flex;
	flex-direction: column;
	gap: 0.25em;
}

#main-container .main-content {
	flex-grow: 1;
	padding-left: min(1em, 2vw);
	padding-right: min(1em, 2vw);
}

footer {
	padding: 1em;
	margin-top: 1em;
	background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
	display: flex;
	justify-content: flex-end;
}

footer span {
	margin-left: 2em;
}

.disconnected-icon {
	position: fixed;
	right: 2em;
	bottom: 3em;
	padding: 1em;
	background-color: darkred;
	border-radius: 0.5em;
	z-index: 999;
	box-shadow: 0 0 10px black;
	font-weight: bold;
}

.custom-swal-popup,
.custom-swal-title,
.custom-swal-content {
	color: #ddd !important;
	background: #282828 !important;
}

select.swal2-input option {
	background-color: #282828;
}

.swal2-timer-progress-bar {
	background: #ddd;
}

.swal2-content pre,
.swal2-html-container pre {
	text-align: left;
	font-size: 0.8em;
	white-space: pre-wrap;
	tab-size: 4;
}

div:where(.swal2-container) .swal2-radio,
div:where(.swal2-container) .swal2-checkbox {
	background: initial;
}

.disconnected-user-popup-container {
	position: absolute;
	user-select: none;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 600;
	border-radius: 0.5em;
	background-color: #00000060;
	display: flex;
	justify-content: center;
	align-items: center;
}

.disconnected-user-popup {
	background-color: #222222;
	text-align: center;
	padding: 2em;
	border-radius: 0.5em;
	min-width: 30%;
}

.disconnected-user-popup h1 {
	margin-top: 0;
}

/* Inputs */

#main-container select,
#main-container option,
#main-container textarea,
#main-container input[type="text"],
#main-container input[type="password"],
#main-container input[type="button"],
#main-container input[type="number"],
#main-container button,
.standard-input,
.check-button + label {
	color: #ddd;
	background-color: #555;
	border-radius: 4px;
	border: 1px solid #888;
	padding: 5px 5px;
	margin: 0.25em;
}

#main-container input[type="button"],
#main-container button {
	box-shadow:
		inset 2px 2px 8px -3px #888,
		inset -2px -2px 8px -3px #000;
}

#main-container input[type="button"]:active:not(:disabled),
#main-container button:active:not(:disabled) {
	box-shadow:
		inset 2px 2px 8px -3px #000,
		inset -2px -2px 8px -3px #888;
	transform: translateY(1px);
}

#main-container button.flat,
#main-container button.flat:active {
	box-shadow: initial;
	background-color: #383838;
}

#main-container button.blue {
	background-color: rgb(0, 62, 145);
	transition: all 0.1s ease;
}

#main-container button.blue:disabled {
	color: rgb(139, 139, 139);
	background-color: rgb(0, 36, 83);
}

#main-container .button,
#main-container button,
#main-container input[type="button"],
#main-container input[type="submit"],
#main-container input[type="reset"],
#main-container input[type="button"],
#main-container .check-button + label {
	display: inline-block;
	height: 28px;
	padding: 7.5px 15px;
	text-align: center;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.1rem;
	text-transform: uppercase;
	text-decoration: none;
	white-space: nowrap;
	background-color: #444;
	cursor: pointer;
	box-sizing: border-box;
	will-change: transform;
	line-height: 1;
}

#main-container .controls button,
#main-container .controls input[type="button"] {
	background-color: #333;
}

#main-container button:disabled {
	color: #555;
	cursor: auto;
}

#main-container .button:hover:enabled,
#main-container button:hover:enabled,
#main-container input[type="submit"]:hover:enabled,
#main-container input[type="reset"]:hover:enabled,
#main-container input[type="button"]:hover:enabled,
.check-button:hover:enabled + label,
#main-container .button:focus,
#main-container button:focus,
#main-container input[type="submit"]:focus,
#main-container input[type="reset"]:focus,
#main-container input[type="button"]:focus,
.check-button + label:focus {
	color: #fff;
	border-color: #bbb;
	outline: 0;
}

#main-container button.confirm {
	background-color: #3085d6;
	text-shadow: 0 0 2px black;
}

#main-container button.confirm:hover {
	background-color: #2972b6;
}

#main-container button.stop {
	background-color: darkred;
}

.check-button-container {
	display: inline-block;
	position: relative;
	margin: 0;
	padding: 0;
}

.check-button {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	-webkit-appearance: none;
	-moz-appearance: none;
	-ms-appearance: none;
	appearance: none;
	border: none;
	padding: 0;
	border-radius: 0;
	vertical-align: middle;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-size: cover;
	background-color: transparent;
	background-position: -10em -10em;
	transition: 0.3s ease;
	outline: 0;
}

.check-button:active + label {
	background-color: #888;
}

.check-button:checked + label {
	box-shadow: 0 0 2px 1px green;
}

.check-button:checked::after {
	font-family: "Mini Font Awesome 5 Free";
	content: "\\f00c";
	z-index: 3;
	font-weight: 900;
	position: absolute;
	top: 0;
	right: 0;
	font-size: 2em;
	color: green;
}

.button-icon {
	position: absolute;
	left: 1.4em;
	top: 50%;
	transform: translate(-50%, -50%);
}

.set-icon {
	display: inline-block;
	height: 1em;
	vertical-align: baseline;
	filter: invert(var(--invertedness));
}

.padded-icon {
	min-width: 3em;
}

.mana-icon {
	display: inline-block;
	height: 1em;
}

.wildcard-icon {
	display: inline-block;
	height: 1em;
	vertical-align: text-top;
}

.land-input {
	white-space: nowrap;
}

/**** checkbox-button ****/

.checkbox-button {
	position: relative;
	display: inline-block;
	margin: 0.5em;
	padding: 0.25em;
	border-radius: 0.25em;
	background-color: #666;
	cursor: pointer;

	height: 25px;
	box-shadow:
		inset 1px 1px 4px 0 #bbb,
		inset -1px -1px 4px 0 #222;
}

.checkbox-button:hover {
	background-color: #888;
}

.checkbox-button[data-checked="true"] {
	box-shadow:
		0px 0px 3px 2px #ccc,
		inset 1px 1px 4px 0 #222,
		inset -1px -1px 4px 0 #bbb;
}

.checkbox-button label {
	line-height: 25px;
}

/* Hide default checkbox */
.checkbox-button input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

@media only screen and (min-width: 1000px) {
	.reload-deck-button {
		float: right;
	}
}

/* Personal Settings */

.personal-settings {
	display: flex;
	gap: 0.75em;
	align-items: center;
	margin-right: 0.25em;
}

.personal-settings-icon {
	min-width: 20px;
	text-align: center;
	user-select: none;
}

/* ** Session Options ** */

.session-options-container {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1em;

	grid-template-areas:
		"option-column-left option-column-right"
		"option-custom-card-list option-custom-card-list";
}

.session-options-container h4 {
	margin: 0.25em;
	margin-top: 0.5em;
	border-bottom: 1px solid #555;
	font-variant: small-caps;
}
.session-options-container h4:first-child {
	margin-top: 0;
}

.option-column-left {
	grid-area: option-column-left;
}

.option-column-right {
	grid-area: option-column-right;
}

.option-custom-card-list {
	grid-area: option-custom-card-list;
	margin: 0.5em;
	padding: 0.5em;
	padding-top: 0;
}

.option-custom-card-list button {
	margin: 0;
}

.option-tooltip {
	max-width: 20vw;
}
.option-tooltip p {
	margin-top: 0.5em;
	margin-bottom: 0.5em;
}

.option-column .line {
	display: flex;
	align-items: center;
}

.option-column-title {
	margin: auto;
	padding: 0.25em;
	text-align: center;
	font-variant: all-small-caps;
}

.option-column .line > label {
	display: inline-block;
	width: min(15rem, 22.5vw);
	text-align: right;
}

.option-column .line .right {
	display: inline-block;
	width: min(15rem, 22.5vw);
}

.option-column .full-line {
	display: flex;
	text-align: center;
}

.option-column .full-line > * {
	flex: 1 1 auto;
	min-width: 0;
}

.option-cube-select {
	background-color: rgba(75, 75, 75, 1);
	border-radius: 6px;
	margin: 0 0 0 0;
	padding: 0.25em 0.5em 0.25em 0.5em;
}

.option-cube-infos {
	padding: 0.75em;
	box-sizing: border-box;
	background: linear-gradient(180deg, rgba(75, 75, 75, 0.1) 0%, rgba(75, 75, 75, 1) 15%);
	border-radius: 0 0 6px 6px;
	min-width: 50vw;
	max-width: 90vw;
	width: 60em;
	margin: auto;
}

.option-section {
	background-color: rgba(255, 255, 255, 0.05);
	border-radius: 0.25em;
	margin-bottom: 0.25em;
}

.option-info {
	text-align: center;
	font-size: 0.8em;
	padding: 0.5em;
}

.file-drop {
	padding: 1em;
	margin: 0.5em 0 0.5em 0;
	border: 4px dashed rgba(255, 255, 255, 0.5);
	background-color: rgba(255, 255, 255, 0.05);
	text-align: center;
}

.dropzone-highlight,
.file-drop:hover {
	color: white;
	border: 4px dashed rgba(255, 255, 255, 1);
}

.option-cube-settings {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1.5em;
}
.option-cube-settings-1 {
	display: flex;
	align-items: center;
	gap: 1.5em;
}
.option-cube-settings-2 {
	display: flex;
	align-items: center;
	gap: 0.5em;
}

.option-cube-import {
	display: flex;
	gap: 0.5em;
}

@media only screen and (max-width: 1000px) {
	.session-options-container {
		grid-template-columns: 1fr;

		grid-template-areas:
			"option-column-left"
			"option-column-right"
			"option-custom-card-list";
	}

	.option-column .line > label {
		width: min(15rem, 45vw);
		text-align: right;
	}

	.option-column .line .right {
		width: min(15rem, 45vw);
	}

	.option-cube-settings,
	.option-cube-settings-1,
	.option-cube-import {
		flex-direction: column;
	}
	.option-cube-settings,
	.option-cube-settings-1 {
		gap: 0;
	}
}

/* ** Welcome ** */

.welcome {
	font-size: 1.1rem;
	padding: min(1.5em, 2vw);
	padding-top: 0;
}

.welcome h1 {
	margin-bottom: 1rem;
}

.welcome .important {
	font-size: 1.4rem;
	margin: 1rem;
}

.welcome-top {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 2vw;
}

@media (max-width: 1200px) {
	.welcome-top {
		flex-direction: column;
		align-items: center;
		align-content: stretch;
	}
}

.welcome-sections {
	width: 85%;
	margin: auto;
}

.welcome-sections .container {
	margin-top: 0.5em;
}

.welcome-sections .section-title {
	--outline-size: 1px;
	text-shadow:
		calc(-1 * var(--outline-size)) calc(-1 * var(--outline-size)) 10px rgb(32, 32, 32),
		var(--outline-size) calc(-1 * var(--outline-size)) 10px rgb(32, 32, 32),
		calc(-1 * var(--outline-size)) var(--outline-size) 10px rgb(32, 32, 32),
		var(--outline-size) var(--outline-size) 10px rgb(32, 32, 32);
}

@media (orientation: portrait) {
	.welcome-sections {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
}

@media (orientation: landscape) {
	.welcome-sections {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: auto auto auto;
		gap: 0 1em;
		grid-template-areas:
			"News News Help"
			"News News Support"
			"News News Tools"
			"PublicSessions PublicSessions PublicSessions";
	}
}

.welcome-section {
	padding: 0.75em;
	background-color: #282828d0;
	border-radius: 10px;
	box-shadow: inset 0 0 8px #383838;
}

.welcome-section ul {
	margin: 0;
	padding: 0;
	list-style-type: none;
}

.welcome-alt {
	background-color: #202020e0;
}

ul.quick-start-list {
	list-style-type: disc;
}
.quick-start-list li {
	margin: 1em;
}

.public-sessions {
	width: 100%;
	--invertedness: 100%;
}

.public-sessions thead {
	background-color: rgba(0, 0, 0, 0.2);
}
.public-sessions tr:nth-child(odd) {
	background-color: rgba(255, 255, 255, 0.025);
}

.public-sessions tr:nth-child(even) {
	background-color: rgba(255, 255, 255, 0.05);
}

.public-sessions tr td.id {
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 11em;
}

.public-sessions tr td.desc {
	width: 80%;
	word-break: break-all;
}

.public-sessions tr td:not(.desc) {
	white-space: nowrap;
	text-align: center;
}

.public-sessions th,
.public-sessions td {
	padding: 0.25em;
}

/* ** Help Modal ** */

.faq p {
	margin-left: 2em;
}

.help-options {
	display: flex;
}

.help-options ul {
	list-style-type: none;
	padding-left: 1em;
	margin-right: 1em;
}

.help-options ul li {
	padding: 0.2em;
	padding-left: 0.5em;
}

.help-options ul li:nth-child(even) {
	background: rgba(0, 0, 0, 0.12);
}

.help-options ul li:nth-child(odd) {
	background: rgba(255, 255, 255, 0.03);
}

.option-name {
	font-variant: small-caps;
}

.container {
	margin-top: 1em;
}

.disable-warning {
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 10;
	transform: translate(-50%, -50%);
	font-variant: small-caps;
	white-space: nowrap;
	font-size: 1em;
	text-shadow: 0px 0px 10px black;
}

.controls-drafting-mask {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	padding: 0 1em;

	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	align-items: center;
	background: linear-gradient(
		to left,
		rgba(32, 32, 32, 1),
		rgba(32, 32, 32, 0) 25%,
		rgba(32, 32, 32, 1) 50%,
		rgba(32, 32, 32, 0) 75%,
		rgba(32, 32, 32, 1) 100%
	);
}

#url-remainder {
	font-variant: small-caps;
	font-weight: bold;
	font-size: 1.5em;
	color: #888;
}

@media (max-width: 640px) {
	.controls-drafting-mask {
		grid-template-columns: 1fr;
		grid-template-rows: 1fr 1fr 1fr;
	}
}

#draft-in-progress {
	white-space: nowrap;
	font-variant: small-caps;
	font-size: 1.5em;
	text-align: center;
}

#draft-controls {
	text-align: right;
}

.main-controls {
	background-color: #333;
	padding: 0.2em 0.5em;
}

.main-controls input[type="checkbox"] {
	margin-right: 0;
}

.card-pool-controls .fas,
#session-controls .far,
#session-controls .fas {
	margin-left: 1px;
	margin-right: 1px;
}

#limited-controls,
#view-controls {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	align-items: baseline;
	position: relative;
}

#limited-controls > * {
	margin-right: 4px;
}

#limited-controls > *:last-child {
	margin-right: inherit;
}

#session-id {
	width: 12em;
}

@media (max-width: 1400px) {
	#user-name,
	#session-id {
		width: 10em;
	}
}

.inline-cube-name {
	display: inline-block;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	max-width: 16em;
}

@media (orientation: portrait) and (max-width: 500px) {
	#limited-controls,
	#view-controls {
		justify-content: space-around;
	}

	#select-language-label {
		display: none;
	}
}

.game-modes-cat {
	margin-bottom: 0.5em;
	display: flex;
	flex-direction: column;
}

.game-modes-cat button {
	display: block;
	width: calc(100% - 0.5em);
	box-sizing: border-box;
}

.game-modes-cat-title {
	text-align: center;
	font-variant: small-caps;
	font-size: 0.75em;
}

.setting-button {
	margin: 0.5em;
}

/**** Session Players ****/

.non-playing-session-owner-name {
	max-width: 4em;
	overflow: hidden;
	white-space: nowrap;
	mask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 90%, transparent);
}

.session-players {
	background: #181818;
	padding: 0.25em 0.5em;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 0.5em;
	border-radius: 0.5em;
	gap: 0.2em;
}

.session-players-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.2em;
	grid-area: session-players-header;
}

.player-list-container {
	flex-grow: 2;
	padding-left: 0.5em;
	padding-right: 0.5em;
	grid-area: player-list;
}

ul.player-list {
	display: inline-flex;
	list-style: none;
	width: 100%;
	padding-left: 0;
	margin: 0;
	flex-wrap: wrap;
	gap: 0.2em 0.8em;
}

.player-list li {
	position: relative;
	display: inline-flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.49em;
	min-width: 6em;
	max-width: 12em;
	background: #282828;
	border-radius: 5px;
	flex: 1 1 6em;
}

.player-list li.self,
.player-table li.self,
.player-list-log li.self {
	box-shadow: inset 0 0 5px 0px rgba(255, 255, 255, 0.3);
}

.current-player {
	box-shadow: 0px 0px 10px 1px rgba(255, 255, 255, 0.5);
}

.player-list li.self.current-player,
.player-table li.self.current-player,
.player-list-log li.self.current-player {
	box-shadow:
		inset 0 0 5px 0px rgba(255, 255, 255, 0.3),
		0px 0px 10px 1px rgba(255, 255, 255, 0.5);
}

.player-list li.draggable {
	transform: translateY(0);
}
.player-list li.draggable:hover {
	transform: translateY(-3px);
	box-shadow: 3px 3px 5px 0 rgba(0, 0, 0, 0.75);
}
.player-list li.draggable.self:hover {
	box-shadow:
		inset 0 0 5px 0px rgba(255, 255, 255, 0.3),
		3px 3px 5px 0 rgba(0, 0, 0, 0.75);
}

.player-list-transition-move,
.player-list-transition-enter-active,
.player-list-transition-leave-active {
	transition: all 0.25s ease !important;
}
.player-list-transition-enter-from,
.player-list-transition-leave-to {
	opacity: 0;
}

.player-name {
	min-width: 3em;
	flex: 1 1 3em;
	overflow: hidden;
	white-space: nowrap;
	mask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 90%, transparent);
}

@media (max-width: 900px) {
	.session-players {
		display: grid;
		grid-template-areas:
			"session-players-header chat"
			"player-list player-list";
		grid-template-columns: fit-content(30%);
	}
	.player-list li {
		flex: 1 1 20vw;
		max-width: none;
	}
}

.move-player {
	color: #555;
	/*font-size: 0.8em;*/
}

.move-player-left {
	position: absolute;
	left: -0.3em;
}

.move-player-right {
	position: absolute;
	right: -0.3em;
}

.status-icons {
	display: inline-flex;
	align-items: center;
}

.status-icons > * {
	margin-left: 0.5em;
	font-size: 14px;
}

.booster-count {
	position: relative;
	min-width: 14px;
}
.booster-count img {
	width: 1em;
	position: absolute;
	top: 50%;
	left: 50%;
	transform-origin: center bottom;
	transform: translate(-50%, -50%);
	filter: drop-shadow(0 0 2px #00000080);
}
.booster-count div {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-weight: 900;
	color: black;
	font-family: "Brush Script MT";
}

/* Booster passing animation */

.booster-fade-in-enter-active,
.slide-fade-right-enter-active,
.slide-fade-right-leave-active,
.slide-fade-left-enter-active,
.slide-fade-left-leave-active {
	pointer-events: none; /* Avoid picking cards during transition */
	transition: all 0.3s ease-in;
}
.slide-fade-left-enter-from,
.slide-fade-right-leave-to {
	transform: translateX(50px);
	opacity: 0;
}

.slide-fade-right-enter-from,
.slide-fade-left-leave-to {
	transform: translateX(-50px);
	opacity: 0;
}

.booster-fade-in-enter-from {
	opacity: 0;
}

.booster-open-leave-active,
.booster-cards-enter-active,
.booster-cards-leave-active {
	pointer-events: none; /* Avoid picking cards during transition */
	transition: all 0.5s;
}

.booster-cards-enter-from.wait {
	opacity: 0;
}

.booster-open-leave-active.selected,
.booster-cards-leave-active.selected {
	transition: all 0.5s;
	width: calc(var(--booster-card-scale) * 200px);
	overflow: visible;
}

.booster-open-leave-active.selected .card-image,
.booster-cards-leave-active.selected .card-image {
	width: calc(var(--booster-card-scale) * 200px);
}

.booster-open-leave-to.selected,
.booster-cards-leave-to.selected {
	transform: translateY(250px) translateX(calc(var(--booster-card-scale) * -100px)); /* translateX compensates for width change */
	z-index: 2;
	opacity: 0;
	width: 0;
	margin: 0;
}

.booster-open-leave-active.burned,
.booster-cards-leave-active.burned {
	animation: card-burn 0.5s;
}

.booster-open-leave-to.burned,
.booster-cards-leave-to.burned {
	margin: 0;
}

@keyframes card-burn {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	25% {
		transform: scale(1.025);
		opacity: 1;
	}
	50% {
		transform: scale(1);
		opacity: 1;
	}
	75% {
		opacity: 1;
	}
	100% {
		transform: scale(0);
		opacity: 0;
	}
}

/**** Draft ****/

.booster {
	position: relative;
	min-height: calc(var(--booster-card-scale) * 282px + 2 * 0.75em);
}

.booster-waiting .wait {
	position: absolute;
	display: flex;
	gap: 0.5em;
	align-items: center;
	text-align: center;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	z-index: 2;
	font-size: 2.5em;
	line-height: 1.5em;
	font-family: Calibri;
	text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
	font-weight: 600;
	white-space: nowrap;
}
.booster-waiting .wait .passing-order {
	margin: 0 2em;
}
.booster-waiting .wait .booster-wait-passing-order-right {
	animation: passing-order-right 3s infinite;
}
.booster-waiting .wait .booster-wait-passing-order-left {
	animation: passing-order-left 3s infinite;
}

@keyframes passing-order-right {
	0% {
		transform: translateX(-2em);
		opacity: 0;
	}
	25% {
		transform: translateX(0);
		opacity: 1;
	}
	75% {
		transform: translateX(0);
		opacity: 1;
	}
	100% {
		transform: translateX(2em);
		opacity: 0;
	}
}

@keyframes passing-order-left {
	0% {
		transform: translateX(2em);
		opacity: 0;
	}
	25% {
		transform: translateX(0);
		opacity: 1;
	}
	75% {
		transform: translateX(0);
		opacity: 1;
	}
	100% {
		transform: translateX(-2em);
		opacity: 0;
	}
}

.booster-waiting {
	pointer-events: none;
	background: repeating-linear-gradient(45deg, #282828, #282828 10px, #222 10px, #222 20px);
}

.booster-waiting .card {
	filter: brightness(50%);
}

.skipped {
	filter: grayscale();
}

#chrono,
.chrono {
	padding: 0.2em;
	padding-left: 0.5em;
	padding-right: 0.5em;

	display: inline-flex;
	align-items: center;
	justify-content: space-between;
	min-width: 2.6em;
	will-change: transform;
}

.section-title {
	display: flex;
	align-items: center;
	margin-left: 1em;
	margin-right: 1em;
	min-height: 35px;
}
.section-title h2 {
	display: inline-block;
	margin: 0;
	font-variant: small-caps;
	font-size: 28px;
}

@media (max-width: 700px) {
	.section-title {
		flex-wrap: wrap;
	}

	#booster-controls {
		flex-direction: column;
	}
}

.controls {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0 1.5em;
	margin-left: 1.5em;
}
@supports not (gap: 1.5em) {
	#main-container .controls > * {
		margin-left: 1.5em;
	}
}

.card-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	background-color: #282828;
	border-radius: 10px;
	box-shadow: inset 0 0 8px #383838;
	padding: 0.5em;
}

.deck-container {
	display: flex;
}

.deck {
	flex: 1 1 auto;
}

.deck-stat-container {
	display: flex;
	gap: 8px;
}

.deck-stat {
	display: flex;
	justify-content: center;
	align-items: center;
}
.deck-stat img {
	width: 16px;
	height: 16px;
	object-fit: contain;
	margin-left: 2px;
	filter: brightness(0.5);
}

.deck-search input {
	max-width: 8em;
}

.swap-controls {
	display: flex;
	gap: 0.75em;
}

.collapsed-sideboard {
	flex: 0 0 auto;
	margin-left: 1em;
	box-sizing: border-box;
}

.collapsed-sideboard h2 {
	font-size: 20px;
	line-height: 28px;
}

.selected.foil .inner-card-image, /* .foil .card-image has an 'overflow:hidden' preventing the box-shadow to show up. We'll apply it earlier in this case. */
.selected .card-image .front-image,
.selected .card-image .back-image,
.selected .card-placeholder {
	--selected-card-shadow-color: rgb(3, 139, 6);
	box-shadow: 0px 0px 4px 2px var(--selected-card-shadow-color);
}

.selected-high .card-image .front-image,
.selected-high .card-image .back-image,
.selected-high .card-placeholder {
	box-shadow: 0px 0px 20px 4px rgba(0, 200, 2, 1);
}

.burned.foil .inner-card-image, /* .foil .card-image has an 'overflow:hidden' preventing the box-shadow to show up. We'll apply it earlier in this case. */
	.burned .card-image .front-image,
	.burned .card-image .back-image,
	.burned .card-placeholder {
	box-shadow: 0px 0px 12px 4px rgb(161, 0, 3);
}

.card:hover {
	z-index: 10;
}

.card-column {
	display: flex;
	flex-direction: column;
	margin-bottom: 0.5em;
	min-height: 300px;
}
.card-column > .column-card-container,
.card-column > .column-card-container > .card,
.card-column > .card {
	height: 0;
	padding-bottom: calc(
		var(--card-title-height-factor, 1) * 13.5%
	); /* As a percentage of the container width, used to display card name (instead of setting a height), makes its 'responsive' */
	margin: 0;
	z-index: 0;
}

/* Bug in webkit applies with style to another element while drag & dropping https://bugs.webkit.org/show_bug.cgi?id=134555 */
.card-column > .column-card-container:hover,
.card-column > .card:hover {
	z-index: 800; /* NOTE: This forces the browser to relayout and is very slow in large lists (especially on Chrome). A solution could be to render a copy instead of bringing it forward, but it's more complicated. */
}

.card-column > .column-card-container:last-child,
.card-column > .column-card-container:last-child > .card,
.card-column > .card:last-child {
	margin-bottom: calc(142.5% - var(--card-title-height-factor, 1) * 13.5%);
}

/* Only use this hover rule on desktop (hover capabilities and a mouse or equivalent device) */
@media (hover: hover) and (pointer: fine) {
	/* No :hover outside of the div bounds, will let the card disappear when the mouse moves outside of it */
	.card-column > .column-card-container > .card > div, /* This version doesn't ~always~ work as expected on Chrome (Sometimes it just fixes itself...), but does in Firefox  */
	.card-column > .card > div {
		pointer-events: none;
	}
	/* Except if its fully visible */
	.card-column > .column-card-container:last-child > .card > div,
	.card-column > .card:last-child > div {
		pointer-events: auto;
	}
}

.drag-column {
	min-width: 200px;
	background-color: rgba(0, 0, 0, 0.1);
	border-radius: 6px;

	transition:
		box-shadow 0.1s ease-in-out,
		background-color 0.1s ease-in-out;
}

.drag-column[drop-active="true"] {
	/*box-shadow: -7px 0 5px -5px white, 7px 0 5px -5px white;*/
	box-shadow: 0 0 4px 3px white;
	background-color: rgba(255, 255, 255, 0.1);
}
/* :has isn't supported on Firefox yet, causing the whole rule to be ignored. This is duplicated on purpose. */
.drag-column:has(.ghost),
.drag-column[drop-active="true"] {
	box-shadow: 0 0 4px 3px white;
	background-color: rgba(255, 255, 255, 0.1);
}

/**** Draft Spectator ****/

.draft-watching-state {
	text-align: center;

	div {
		margin-bottom: 1em;
	}
}

.loading {
	position: fixed;
	z-index: 999;
	height: 2em;
	width: 2em;
	overflow: visible;
	margin: auto;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
}

/* Transparent Overlay */
.loading:before {
	content: "";
	display: block;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.8);
}

.loading + span {
	position: fixed;
	top: calc(50vh + 2em);
	right: 0;
	left: 0;
	z-index: 1000;
	text-align: center;
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
	/* hide "loading..." text */
	font: 0/0 a;
	color: transparent;
	text-shadow: none;
	background-color: transparent;
	border: 0;
}

.loading:not(:required):after {
	--spinner-color: rgba(255, 255, 255, 0.75);
	content: "";
	display: block;
	font-size: 10px;
	width: 1em;
	height: 1em;
	margin-top: -0.5em;
	-webkit-animation: spinner 1500ms infinite linear;
	-moz-animation: spinner 1500ms infinite linear;
	-ms-animation: spinner 1500ms infinite linear;
	-o-animation: spinner 1500ms infinite linear;
	animation: spinner 1500ms infinite linear;
	border-radius: 0.5em;
	-webkit-box-shadow:
		var(--spinner-color) 1.5em 0 0 0,
		var(--spinner-color) 1.1em 1.1em 0 0,
		var(--spinner-color) 0 1.5em 0 0,
		var(--spinner-color) -1.1em 1.1em 0 0,
		rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
		rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0,
		var(--spinner-color) 0 -1.5em 0 0,
		var(--spinner-color) 1.1em -1.1em 0 0;
	box-shadow:
		var(--spinner-color) 1.5em 0 0 0,
		var(--spinner-color) 1.1em 1.1em 0 0,
		var(--spinner-color) 0 1.5em 0 0,
		var(--spinner-color) -1.1em 1.1em 0 0,
		var(--spinner-color) -1.5em 0 0 0,
		var(--spinner-color) -1.1em -1.1em 0 0,
		var(--spinner-color) 0 -1.5em 0 0,
		var(--spinner-color) 1.1em -1.1em 0 0;
}

@keyframes spinner {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.shaking {
	animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
	transform: translate3d(0, 0, 0);
	backface-visibility: hidden;
	perspective: 1000px;
}

@keyframes shake {
	10%,
	90% {
		transform: translate3d(-1px, 0, 0);
	}

	20%,
	80% {
		transform: translate3d(2px, 0, 0);
	}

	30%,
	50%,
	70% {
		transform: translate3d(-4px, 0, 0);
	}

	40%,
	60% {
		transform: translate3d(4px, 0, 0);
	}
}

.pulsing {
	animation: pulse 0.4s;
	box-shadow: 0 0 0 0 rgba(200, 0, 0, 1);
	transform: scale(1);
}

@keyframes pulse {
	0% {
		transform: scale(1.1);
		box-shadow: 0 0 0 0 rgba(200, 0, 0, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(200, 0, 0, 0);
	}

	100% {
		transform: scale(1);
		box-shadow: 0 0 0 0 rgba(200, 0, 0, 0);
	}
}

.rochester-container {
	display: flex;
	align-items: flex-start;
}

/*
Can't be applied to .card-filtered directly as it creates a bug with the rotation handle position.
See: https://stackoverflow.com/questions/52937708/why-does-applying-a-css-filter-on-the-parent-break-the-child-positioning
*/
.card-filtered .card-image img {
	filter: brightness(35%) saturate(50%);
}

.card-image img {
	transition: filter 0.2s;
}

.fixed-deck-and-sideboard-container {
	box-sizing: border-box;
	position: fixed;
	bottom: 0px;
	left: 0px;
	right: 0px;
	height: 400px;
	margin: 0px;
	background-color: rgb(32, 32, 32);
	z-index: 800;
	box-shadow: 0 -4px 5px #000;
}

.deck-and-sideboard-container-resize-bar {
	position: absolute;
	top: -1px;
	left: 0;
	right: 0;
	height: 2px;
	background-color: #888;
	border-top: 1px solid #bbb;
	border-bottom: 1px solid #222;
	cursor: ns-resize;
	z-index: 801;
}

.fixed-deck-and-sideboard-close {
	position: absolute;
	top: 6px;
	right: 6px;
}

.fixed-deck-and-sideboard-container .deck-and-sideboard {
	box-sizing: border-box;
	position: relative;
	overflow: auto;
	padding: 1em;
	padding-top: 0;
	max-height: 100%;
}

.fixed-deck-and-sideboard-container .deck-container {
	margin-top: 0.25em;
}

.v-popper__popper {
	pointer-events: none;
}

.v-popper--theme-dropdown .v-popper__inner {
	background: #404040;
	color: #ddd;
	border-color: #606060;
}

.v-popper--theme-dropdown .v-popper__arrow-inner {
	border-color: #404040;
}

.v-popper--theme-dropdown.v-popper__popper {
	z-index: 1010;
}

.timer-icon {
	--timer-max: 75;
	--timer-current: 75;
	position: relative;
}

.timer-icon-moving {
	position: absolute;
	bottom: 6.6px;
	left: calc(50% - 1px);
	width: 2px;
	height: 7px;
	background-color: #222;
	border-radius: 10px;

	will-change: transform;
	transform-origin: 50% calc(100% - 1px);
	transition: transform 1s linear;
	transform: rotate(calc(-360deg * min(var(--timer-max), var(--timer-current)) / var(--timer-max)));
}

.multi-drag-selected::before {
	content: "";
	position: absolute;
	top: -10%;
	left: -1.5%;
	right: -1.5%;
	bottom: -20%;
	border-radius: 3.5%/28% 28% 24% 24%;
	background-color: #518ae6d0;
}

/* Temp Draft Queue Banner */
.draft-queue-banner {
	position: relative;
	max-width: min(500px, 90wv);
}

.draft-queue-banner img {
	border-radius: 12px;
	box-shadow:
		0 4px 8px 0 rgba(0, 0, 0, 0.2),
		0 6px 20px 0 rgba(0, 0, 0, 0.19);
	max-width: 100%;
	height: auto;
	transition: all 0.2s;
}

.draft-queue-banner:hover img {
	box-shadow:
		0 0 4px 0px rgba(255, 255, 255, 0.8),
		0 0 20px 0px #72a7ff,
		0 4px 8px 0 rgba(0, 0, 0, 0.2),
		0 6px 20px 0 rgba(0, 0, 0, 0.19);
	filter: saturate(1.2);
}
`, "",{"version":3,"sources":["webpack://./client/src/css/app.css"],"names":[],"mappings":"AAAA;CACC;;EAEC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;AACA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,yEAAyE;CACzE,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,UAAU;CACV,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,oBAAoB;CACpB,YAAY;CACZ,0BAA0B;CAC1B,iBAAiB;AAClB;;AAEA;;;CAGC,sBAAsB;CACtB,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,gBAAgB;CAChB,gBAAgB;CAChB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,MAAM;CACN,SAAS;CACT,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,oBAAoB;CACpB,2BAA2B;CAC3B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,oBAAoB;CACpB,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA,WAAW;;AAEX;;;;;;;;;;CAUC,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;CAChB,cAAc;AACf;;AAEA;;CAEC;;+BAE8B;AAC/B;;AAEA;;CAEC;;+BAE8B;CAC9B,0BAA0B;AAC3B;;AAEA;;CAEC,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,iCAAiC;CACjC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;AACjC;;AAEA;;;;;;;CAOC,qBAAqB;CACrB,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,qBAAqB;CACrB,mBAAmB;CACnB,sBAAsB;CACtB,eAAe;CACf,sBAAsB;CACtB,sBAAsB;CACtB,cAAc;AACf;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;;;;;;;;;;;;CAYC,WAAW;CACX,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,YAAY;CACZ,wBAAwB;CACxB,qBAAqB;CACrB,oBAAoB;CACpB,gBAAgB;CAChB,YAAY;CACZ,UAAU;CACV,gBAAgB;CAChB,sBAAsB;CACtB,yDAAoiB;CACpiB,4BAA4B;CAC5B,sBAAsB;CACtB,6BAA6B;CAC7B,gCAAgC;CAChC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,uCAAuC;CACvC,gBAAgB;CAChB,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,cAAc;CACd,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,wBAAwB;CACxB,mCAAmC;AACpC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;AACpB;;AAEA,0BAA0B;;AAE1B;CACC,kBAAkB;CAClB,qBAAqB;CACrB,aAAa;CACb,eAAe;CACf,qBAAqB;CACrB,sBAAsB;CACtB,eAAe;;CAEf,YAAY;CACZ;;4BAE2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC;;;4BAG2B;AAC5B;;AAEA;CACC,iBAAiB;AAClB;;AAEA,0BAA0B;AAC1B;CACC,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,SAAS;CACT,QAAQ;AACT;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA,sBAAsB;;AAEtB;CACC,aAAa;CACb,WAAW;CACX,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA,0BAA0B;;AAE1B;CACC,aAAa;CACb,8BAA8B;CAC9B,QAAQ;;CAER;;mDAEkD;AACnD;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,6BAA6B;CAC7B,wBAAwB;AACzB;AACA;CACC,aAAa;AACd;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,kCAAkC;CAClC,aAAa;CACb,cAAc;CACd,cAAc;AACf;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,YAAY;AACb;;AAEA;CACC,qCAAqC;CACrC,kBAAkB;CAClB,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,sBAAsB;CACtB,sFAAsF;CACtF,0BAA0B;CAC1B,eAAe;CACf,eAAe;CACf,WAAW;CACX,YAAY;AACb;;AAEA;CACC,2CAA2C;CAC3C,qBAAqB;CACrB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,2CAA2C;CAC3C,2CAA2C;CAC3C,kBAAkB;AACnB;;AAEA;;CAEC,YAAY;CACZ,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,UAAU;AACX;;AAEA;CACC;EACC,0BAA0B;;EAE1B;;;4BAG0B;CAC3B;;CAEA;EACC,uBAAuB;EACvB,iBAAiB;CAClB;;CAEA;EACC,uBAAuB;CACxB;;CAEA;;;EAGC,sBAAsB;CACvB;CACA;;EAEC,MAAM;CACP;AACD;;AAEA,kBAAkB;;AAElB;CACC,iBAAiB;CACjB,wBAAwB;CACxB,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC;EACC,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;CACvB;AACD;;AAEA;CACC,UAAU;CACV,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB;;;;8DAI6D;AAC9D;;AAEA;CACC;EACC,aAAa;EACb,sBAAsB;EACtB,WAAW;CACZ;AACD;;AAEA;CACC;EACC,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,UAAU;EACV;;;;iDAI+C;CAChD;AACD;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,mBAAmB;CACnB,iCAAiC;AAClC;;AAEA;CACC,SAAS;CACT,UAAU;CACV,qBAAqB;AACtB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,4CAA4C;AAC7C;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;;CAEC,eAAe;AAChB;;AAEA,qBAAqB;;AAErB;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,gCAAgC;CAChC,wBAAwB;CACxB,mBAAmB;CACnB,cAAc;CACd,+BAA+B;AAChC;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,MAAM;CACN,SAAS;CACT,cAAc;;CAEd,aAAa;CACb,kCAAkC;CAClC,mBAAmB;CACnB;;;;;;;EAOC;AACF;;AAEA;CACC,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC;EACC,0BAA0B;EAC1B,+BAA+B;CAChC;AACD;;AAEA;CACC,mBAAmB;CACnB,wBAAwB;CACxB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,oBAAoB;AACrB;;AAEA;CACC,eAAe;AAChB;;AAEA;;;CAGC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;;CAEC,aAAa;CACb,8BAA8B;CAC9B,eAAe;CACf,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;;EAEC,WAAW;CACZ;AACD;;AAEA;CACC,qBAAqB;CACrB,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC;;EAEC,6BAA6B;CAC9B;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC,oBAAoB;CACpB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,wBAAwB;CACxB,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA,0BAA0B;;AAE1B;CACC,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,wEAAwE;AACzE;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,eAAe;CACf,oBAAoB;CACpB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,UAAU;CACV,iCAAiC;AAClC;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,SAAS;CACT,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,8BAA8B;CAC9B,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;AACd;;AAEA;;;CAGC,sDAAsD;AACvD;;AAEA;CACC,qDAAqD;AACtD;;AAEA;;;CAGC;;2CAE0C;AAC3C;;AAEA;CACC,wBAAwB;AACzB;AACA;CACC,2BAA2B;CAC3B,6CAA6C;AAC9C;AACA;CACC;;mCAEkC;AACnC;;AAEA;;;CAGC,qCAAqC;AACtC;AACA;;CAEC,UAAU;AACX;;AAEA;CACC,cAAc;CACd,aAAa;CACb,gBAAgB;CAChB,mBAAmB;CACnB,wEAAwE;AACzE;;AAEA;CACC;EACC,aAAa;EACb;;4BAE0B;EAC1B,uCAAuC;CACxC;CACA;EACC,cAAc;EACd,eAAe;CAChB;AACD;;AAEA;CACC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,+BAA+B;CAC/B,gCAAgC;CAChC,sCAAsC;AACvC;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,gBAAgB;CAChB,YAAY;CACZ,8BAA8B;AAC/B;;AAEA,8BAA8B;;AAE9B;;;;;CAKC,oBAAoB,EAAE,0CAA0C;CAChE,4BAA4B;AAC7B;AACA;;CAEC,2BAA2B;CAC3B,UAAU;AACX;;AAEA;;CAEC,4BAA4B;CAC5B,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;;;CAGC,oBAAoB,EAAE,0CAA0C;CAChE,oBAAoB;AACrB;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,oBAAoB;CACpB,8CAA8C;CAC9C,iBAAiB;AAClB;;AAEA;;CAEC,8CAA8C;AAC/C;;AAEA;;CAEC,iFAAiF,EAAE,4CAA4C;CAC/H,UAAU;CACV,UAAU;CACV,QAAQ;CACR,SAAS;AACV;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,SAAS;AACV;;AAEA;CACC;EACC,mBAAmB;EACnB,UAAU;CACX;CACA;EACC,uBAAuB;EACvB,UAAU;CACX;CACA;EACC,mBAAmB;EACnB,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,mBAAmB;EACnB,UAAU;CACX;AACD;;AAEA,gBAAgB;;AAEhB;CACC,kBAAkB;CAClB,gEAAgE;AACjE;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,UAAU;CACV,mBAAmB;CACnB,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,4CAA4C;CAC5C,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,oBAAoB;CACpB,uCAAuC;CACvC,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,aAAa;AACd;AACA;CACC,0CAA0C;AAC3C;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC;EACC,2BAA2B;EAC3B,UAAU;CACX;CACA;EACC,wBAAwB;EACxB,UAAU;CACX;CACA;EACC,wBAAwB;EACxB,UAAU;CACX;CACA;EACC,0BAA0B;EAC1B,UAAU;CACX;AACD;;AAEA;CACC;EACC,0BAA0B;EAC1B,UAAU;CACX;CACA;EACC,wBAAwB;EACxB,UAAU;CACX;CACA;EACC,wBAAwB;EACxB,UAAU;CACX;CACA;EACC,2BAA2B;EAC3B,UAAU;CACX;AACD;;AAEA;CACC,oBAAoB;CACpB,yFAAyF;AAC1F;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,cAAc;CACd,mBAAmB;CACnB,oBAAoB;;CAEpB,oBAAoB;CACpB,mBAAmB;CACnB,8BAA8B;CAC9B,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,SAAS;CACT,wBAAwB;CACxB,eAAe;AAChB;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,aAAa;CACb,eAAe;CACf,uBAAuB;CACvB,yBAAyB;CACzB,mBAAmB;CACnB,iCAAiC;CACjC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;;CAIC,4CAA4C;CAC5C,6DAA6D;AAC9D;;AAEA;;;CAGC,+CAA+C;AAChD;;AAEA;;;;CAIC,2CAA2C;AAC5C;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,oBAAoB;CACpB,iBAAiB;AAClB;AACA;;;CAGC,SAAS;CACT;;EAEC,EAAE,4HAA4H;CAC/H,SAAS;CACT,UAAU;AACX;;AAEA,6HAA6H;AAC7H;;CAEC,YAAY,EAAE,sMAAsM;AACrN;;AAEA;;;CAGC,wEAAwE;AACzE;;AAEA,8FAA8F;AAC9F;CACC,wGAAwG;CACxG;;EAEC,oBAAoB;CACrB;CACA,gCAAgC;CAChC;;EAEC,oBAAoB;CACrB;AACD;;AAEA;CACC,gBAAgB;CAChB,oCAAoC;CACpC,kBAAkB;;CAElB;;mCAEkC;AACnC;;AAEA;CACC,2DAA2D;CAC3D,6BAA6B;CAC7B,0CAA0C;AAC3C;AACA,8GAA8G;AAC9G;;CAEC,6BAA6B;CAC7B,0CAA0C;AAC3C;;AAEA,0BAA0B;;AAE1B;CACC,kBAAkB;;CAElB;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,WAAW;CACX,UAAU;CACV,iBAAiB;CACjB,YAAY;CACZ,MAAM;CACN,OAAO;CACP,SAAS;CACT,QAAQ;AACT;;AAEA,wBAAwB;AACxB;CACC,WAAW;CACX,cAAc;CACd,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,oCAAoC;AACrC;;AAEA;CACC,eAAe;CACf,qBAAqB;CACrB,QAAQ;CACR,OAAO;CACP,aAAa;CACb,kBAAkB;AACnB;;AAEA,yDAAyD;AACzD;CACC,2BAA2B;CAC3B,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,6BAA6B;CAC7B,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,WAAW;CACX,cAAc;CACd,eAAe;CACf,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,iDAAiD;CACjD,8CAA8C;CAC9C,6CAA6C;CAC7C,4CAA4C;CAC5C,yCAAyC;CACzC,oBAAoB;CACpB;;;;;;;;uCAQsC;CACtC;;;;;;;;uCAQsC;AACvC;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC,gEAAgE;CAChE,+BAA+B;CAC/B,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC;;EAEC,kCAAkC;CACnC;;CAEA;;EAEC,iCAAiC;CAClC;;CAEA;;;EAGC,kCAAkC;CACnC;;CAEA;;EAEC,iCAAiC;CAClC;AACD;;AAEA;CACC,qBAAqB;CACrB,sCAAsC;CACtC,mBAAmB;AACpB;;AAEA;CACC;EACC,qBAAqB;EACrB,wCAAwC;CACzC;;CAEA;EACC,mBAAmB;EACnB,yCAAyC;CAC1C;;CAEA;EACC,mBAAmB;EACnB,sCAAsC;CACvC;AACD;;AAEA;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;;;CAGC;AACD;CACC,qCAAqC;AACtC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,SAAS;CACT,UAAU;CACV,aAAa;CACb,WAAW;CACX,iCAAiC;CACjC,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,WAAW;CACX,sBAAsB;CACtB,0BAA0B;CAC1B,6BAA6B;CAC7B,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,qBAAqB;CACrB,UAAU;CACV,WAAW;CACX,sBAAsB;CACtB,mBAAmB;;CAEnB,sBAAsB;CACtB,sCAAsC;CACtC,+BAA+B;CAC/B,iGAAiG;AAClG;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,mCAAmC;CACnC,2BAA2B;AAC5B;;AAEA,4BAA4B;AAC5B;CACC,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;CACnB;;kCAEiC;CACjC,eAAe;CACf,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC;;;;kCAIiC;CACjC,qBAAqB;AACtB","sourcesContent":["@media only screen and (min-width: 800px) {\n\tbody,\n\t#main-container {\n\t\toverflow-x: hidden;\n\t}\n}\n\n@media (max-width: 1400px) {\n\t.remove-below-1400 {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media (max-width: 1200px) {\n\t.remove-below-1200 {\n\t\tdisplay: none !important;\n\t}\n}\n@media (max-width: 1000px) {\n\t.remove-below-1000 {\n\t\tdisplay: none !important;\n\t}\n}\n\nbody {\n\toverflow-y: hidden;\n}\n\n#main-container {\n\tbox-sizing: border-box;\n\tposition: relative;\n\toverflow-y: auto;\n\theight: 100vh;\n\tpadding-top: 0.25em;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.25em;\n}\n\n#main-container .main-content {\n\tflex-grow: 1;\n\tpadding-left: min(1em, 2vw);\n\tpadding-right: min(1em, 2vw);\n}\n\nfooter {\n\tpadding: 1em;\n\tmargin-top: 1em;\n\tbackground: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\nfooter span {\n\tmargin-left: 2em;\n}\n\n.disconnected-icon {\n\tposition: fixed;\n\tright: 2em;\n\tbottom: 3em;\n\tpadding: 1em;\n\tbackground-color: darkred;\n\tborder-radius: 0.5em;\n\tz-index: 999;\n\tbox-shadow: 0 0 10px black;\n\tfont-weight: bold;\n}\n\n.custom-swal-popup,\n.custom-swal-title,\n.custom-swal-content {\n\tcolor: #ddd !important;\n\tbackground: #282828 !important;\n}\n\nselect.swal2-input option {\n\tbackground-color: #282828;\n}\n\n.swal2-timer-progress-bar {\n\tbackground: #ddd;\n}\n\n.swal2-content pre,\n.swal2-html-container pre {\n\ttext-align: left;\n\tfont-size: 0.8em;\n\twhite-space: pre-wrap;\n\ttab-size: 4;\n}\n\ndiv:where(.swal2-container) .swal2-radio,\ndiv:where(.swal2-container) .swal2-checkbox {\n\tbackground: initial;\n}\n\n.disconnected-user-popup-container {\n\tposition: absolute;\n\tuser-select: none;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 600;\n\tborder-radius: 0.5em;\n\tbackground-color: #00000060;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.disconnected-user-popup {\n\tbackground-color: #222222;\n\ttext-align: center;\n\tpadding: 2em;\n\tborder-radius: 0.5em;\n\tmin-width: 30%;\n}\n\n.disconnected-user-popup h1 {\n\tmargin-top: 0;\n}\n\n/* Inputs */\n\n#main-container select,\n#main-container option,\n#main-container textarea,\n#main-container input[type=\"text\"],\n#main-container input[type=\"password\"],\n#main-container input[type=\"button\"],\n#main-container input[type=\"number\"],\n#main-container button,\n.standard-input,\n.check-button + label {\n\tcolor: #ddd;\n\tbackground-color: #555;\n\tborder-radius: 4px;\n\tborder: 1px solid #888;\n\tpadding: 5px 5px;\n\tmargin: 0.25em;\n}\n\n#main-container input[type=\"button\"],\n#main-container button {\n\tbox-shadow:\n\t\tinset 2px 2px 8px -3px #888,\n\t\tinset -2px -2px 8px -3px #000;\n}\n\n#main-container input[type=\"button\"]:active:not(:disabled),\n#main-container button:active:not(:disabled) {\n\tbox-shadow:\n\t\tinset 2px 2px 8px -3px #000,\n\t\tinset -2px -2px 8px -3px #888;\n\ttransform: translateY(1px);\n}\n\n#main-container button.flat,\n#main-container button.flat:active {\n\tbox-shadow: initial;\n\tbackground-color: #383838;\n}\n\n#main-container button.blue {\n\tbackground-color: rgb(0, 62, 145);\n\ttransition: all 0.1s ease;\n}\n\n#main-container button.blue:disabled {\n\tcolor: rgb(139, 139, 139);\n\tbackground-color: rgb(0, 36, 83);\n}\n\n#main-container .button,\n#main-container button,\n#main-container input[type=\"button\"],\n#main-container input[type=\"submit\"],\n#main-container input[type=\"reset\"],\n#main-container input[type=\"button\"],\n#main-container .check-button + label {\n\tdisplay: inline-block;\n\theight: 28px;\n\tpadding: 7.5px 15px;\n\ttext-align: center;\n\tfont-size: 11px;\n\tfont-weight: 600;\n\tletter-spacing: 0.1rem;\n\ttext-transform: uppercase;\n\ttext-decoration: none;\n\twhite-space: nowrap;\n\tbackground-color: #444;\n\tcursor: pointer;\n\tbox-sizing: border-box;\n\twill-change: transform;\n\tline-height: 1;\n}\n\n#main-container .controls button,\n#main-container .controls input[type=\"button\"] {\n\tbackground-color: #333;\n}\n\n#main-container button:disabled {\n\tcolor: #555;\n\tcursor: auto;\n}\n\n#main-container .button:hover:enabled,\n#main-container button:hover:enabled,\n#main-container input[type=\"submit\"]:hover:enabled,\n#main-container input[type=\"reset\"]:hover:enabled,\n#main-container input[type=\"button\"]:hover:enabled,\n.check-button:hover:enabled + label,\n#main-container .button:focus,\n#main-container button:focus,\n#main-container input[type=\"submit\"]:focus,\n#main-container input[type=\"reset\"]:focus,\n#main-container input[type=\"button\"]:focus,\n.check-button + label:focus {\n\tcolor: #fff;\n\tborder-color: #bbb;\n\toutline: 0;\n}\n\n#main-container button.confirm {\n\tbackground-color: #3085d6;\n\ttext-shadow: 0 0 2px black;\n}\n\n#main-container button.confirm:hover {\n\tbackground-color: #2972b6;\n}\n\n#main-container button.stop {\n\tbackground-color: darkred;\n}\n\n.check-button-container {\n\tdisplay: inline-block;\n\tposition: relative;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.check-button {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\t-ms-appearance: none;\n\tappearance: none;\n\tborder: none;\n\tpadding: 0;\n\tborder-radius: 0;\n\tvertical-align: middle;\n\tbackground-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='512px' height='512px' viewBox='0 0 32 32' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3e%3cpath d='M448,71.9c-17.3-13.4-41.5-9.3-54.1,9.1L214,344.2l-99.1-107.3c-14.6-16.6-39.1-17.4-54.7-1.8 c-15.6,15.5-16.4,41.6-1.7,58.1c0,0,120.4,133.6,137.7,147c17.3,13.4,41.5,9.3,54.1-9.1l206.3-301.7 C469.2,110.9,465.3,85.2,448,71.9z'/%3e%3c/svg%3e\");\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-color: transparent;\n\tbackground-position: -10em -10em;\n\ttransition: 0.3s ease;\n\toutline: 0;\n}\n\n.check-button:active + label {\n\tbackground-color: #888;\n}\n\n.check-button:checked + label {\n\tbox-shadow: 0 0 2px 1px green;\n}\n\n.check-button:checked::after {\n\tfont-family: \"Mini Font Awesome 5 Free\";\n\tcontent: \"\\f00c\";\n\tz-index: 3;\n\tfont-weight: 900;\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tfont-size: 2em;\n\tcolor: green;\n}\n\n.button-icon {\n\tposition: absolute;\n\tleft: 1.4em;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n}\n\n.set-icon {\n\tdisplay: inline-block;\n\theight: 1em;\n\tvertical-align: baseline;\n\tfilter: invert(var(--invertedness));\n}\n\n.padded-icon {\n\tmin-width: 3em;\n}\n\n.mana-icon {\n\tdisplay: inline-block;\n\theight: 1em;\n}\n\n.wildcard-icon {\n\tdisplay: inline-block;\n\theight: 1em;\n\tvertical-align: text-top;\n}\n\n.land-input {\n\twhite-space: nowrap;\n}\n\n/**** checkbox-button ****/\n\n.checkbox-button {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin: 0.5em;\n\tpadding: 0.25em;\n\tborder-radius: 0.25em;\n\tbackground-color: #666;\n\tcursor: pointer;\n\n\theight: 25px;\n\tbox-shadow:\n\t\tinset 1px 1px 4px 0 #bbb,\n\t\tinset -1px -1px 4px 0 #222;\n}\n\n.checkbox-button:hover {\n\tbackground-color: #888;\n}\n\n.checkbox-button[data-checked=\"true\"] {\n\tbox-shadow:\n\t\t0px 0px 3px 2px #ccc,\n\t\tinset 1px 1px 4px 0 #222,\n\t\tinset -1px -1px 4px 0 #bbb;\n}\n\n.checkbox-button label {\n\tline-height: 25px;\n}\n\n/* Hide default checkbox */\n.checkbox-button input {\n\tposition: absolute;\n\topacity: 0;\n\tcursor: pointer;\n\theight: 0;\n\twidth: 0;\n}\n\n@media only screen and (min-width: 1000px) {\n\t.reload-deck-button {\n\t\tfloat: right;\n\t}\n}\n\n/* Personal Settings */\n\n.personal-settings {\n\tdisplay: flex;\n\tgap: 0.75em;\n\talign-items: center;\n\tmargin-right: 0.25em;\n}\n\n.personal-settings-icon {\n\tmin-width: 20px;\n\ttext-align: center;\n\tuser-select: none;\n}\n\n/* ** Session Options ** */\n\n.session-options-container {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 1em;\n\n\tgrid-template-areas:\n\t\t\"option-column-left option-column-right\"\n\t\t\"option-custom-card-list option-custom-card-list\";\n}\n\n.session-options-container h4 {\n\tmargin: 0.25em;\n\tmargin-top: 0.5em;\n\tborder-bottom: 1px solid #555;\n\tfont-variant: small-caps;\n}\n.session-options-container h4:first-child {\n\tmargin-top: 0;\n}\n\n.option-column-left {\n\tgrid-area: option-column-left;\n}\n\n.option-column-right {\n\tgrid-area: option-column-right;\n}\n\n.option-custom-card-list {\n\tgrid-area: option-custom-card-list;\n\tmargin: 0.5em;\n\tpadding: 0.5em;\n\tpadding-top: 0;\n}\n\n.option-custom-card-list button {\n\tmargin: 0;\n}\n\n.option-tooltip {\n\tmax-width: 20vw;\n}\n.option-tooltip p {\n\tmargin-top: 0.5em;\n\tmargin-bottom: 0.5em;\n}\n\n.option-column .line {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.option-column-title {\n\tmargin: auto;\n\tpadding: 0.25em;\n\ttext-align: center;\n\tfont-variant: all-small-caps;\n}\n\n.option-column .line > label {\n\tdisplay: inline-block;\n\twidth: min(15rem, 22.5vw);\n\ttext-align: right;\n}\n\n.option-column .line .right {\n\tdisplay: inline-block;\n\twidth: min(15rem, 22.5vw);\n}\n\n.option-column .full-line {\n\tdisplay: flex;\n\ttext-align: center;\n}\n\n.option-column .full-line > * {\n\tflex: 1 1 auto;\n\tmin-width: 0;\n}\n\n.option-cube-select {\n\tbackground-color: rgba(75, 75, 75, 1);\n\tborder-radius: 6px;\n\tmargin: 0 0 0 0;\n\tpadding: 0.25em 0.5em 0.25em 0.5em;\n}\n\n.option-cube-infos {\n\tpadding: 0.75em;\n\tbox-sizing: border-box;\n\tbackground: linear-gradient(180deg, rgba(75, 75, 75, 0.1) 0%, rgba(75, 75, 75, 1) 15%);\n\tborder-radius: 0 0 6px 6px;\n\tmin-width: 50vw;\n\tmax-width: 90vw;\n\twidth: 60em;\n\tmargin: auto;\n}\n\n.option-section {\n\tbackground-color: rgba(255, 255, 255, 0.05);\n\tborder-radius: 0.25em;\n\tmargin-bottom: 0.25em;\n}\n\n.option-info {\n\ttext-align: center;\n\tfont-size: 0.8em;\n\tpadding: 0.5em;\n}\n\n.file-drop {\n\tpadding: 1em;\n\tmargin: 0.5em 0 0.5em 0;\n\tborder: 4px dashed rgba(255, 255, 255, 0.5);\n\tbackground-color: rgba(255, 255, 255, 0.05);\n\ttext-align: center;\n}\n\n.dropzone-highlight,\n.file-drop:hover {\n\tcolor: white;\n\tborder: 4px dashed rgba(255, 255, 255, 1);\n}\n\n.option-cube-settings {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 1.5em;\n}\n.option-cube-settings-1 {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 1.5em;\n}\n.option-cube-settings-2 {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.5em;\n}\n\n.option-cube-import {\n\tdisplay: flex;\n\tgap: 0.5em;\n}\n\n@media only screen and (max-width: 1000px) {\n\t.session-options-container {\n\t\tgrid-template-columns: 1fr;\n\n\t\tgrid-template-areas:\n\t\t\t\"option-column-left\"\n\t\t\t\"option-column-right\"\n\t\t\t\"option-custom-card-list\";\n\t}\n\n\t.option-column .line > label {\n\t\twidth: min(15rem, 45vw);\n\t\ttext-align: right;\n\t}\n\n\t.option-column .line .right {\n\t\twidth: min(15rem, 45vw);\n\t}\n\n\t.option-cube-settings,\n\t.option-cube-settings-1,\n\t.option-cube-import {\n\t\tflex-direction: column;\n\t}\n\t.option-cube-settings,\n\t.option-cube-settings-1 {\n\t\tgap: 0;\n\t}\n}\n\n/* ** Welcome ** */\n\n.welcome {\n\tfont-size: 1.1rem;\n\tpadding: min(1.5em, 2vw);\n\tpadding-top: 0;\n}\n\n.welcome h1 {\n\tmargin-bottom: 1rem;\n}\n\n.welcome .important {\n\tfont-size: 1.4rem;\n\tmargin: 1rem;\n}\n\n.welcome-top {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 2vw;\n}\n\n@media (max-width: 1200px) {\n\t.welcome-top {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\talign-content: stretch;\n\t}\n}\n\n.welcome-sections {\n\twidth: 85%;\n\tmargin: auto;\n}\n\n.welcome-sections .container {\n\tmargin-top: 0.5em;\n}\n\n.welcome-sections .section-title {\n\t--outline-size: 1px;\n\ttext-shadow:\n\t\tcalc(-1 * var(--outline-size)) calc(-1 * var(--outline-size)) 10px rgb(32, 32, 32),\n\t\tvar(--outline-size) calc(-1 * var(--outline-size)) 10px rgb(32, 32, 32),\n\t\tcalc(-1 * var(--outline-size)) var(--outline-size) 10px rgb(32, 32, 32),\n\t\tvar(--outline-size) var(--outline-size) 10px rgb(32, 32, 32);\n}\n\n@media (orientation: portrait) {\n\t.welcome-sections {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t}\n}\n\n@media (orientation: landscape) {\n\t.welcome-sections {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr 1fr;\n\t\tgrid-template-rows: auto auto auto;\n\t\tgap: 0 1em;\n\t\tgrid-template-areas:\n\t\t\t\"News News Help\"\n\t\t\t\"News News Support\"\n\t\t\t\"News News Tools\"\n\t\t\t\"PublicSessions PublicSessions PublicSessions\";\n\t}\n}\n\n.welcome-section {\n\tpadding: 0.75em;\n\tbackground-color: #282828d0;\n\tborder-radius: 10px;\n\tbox-shadow: inset 0 0 8px #383838;\n}\n\n.welcome-section ul {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n}\n\n.welcome-alt {\n\tbackground-color: #202020e0;\n}\n\nul.quick-start-list {\n\tlist-style-type: disc;\n}\n.quick-start-list li {\n\tmargin: 1em;\n}\n\n.public-sessions {\n\twidth: 100%;\n\t--invertedness: 100%;\n}\n\n.public-sessions thead {\n\tbackground-color: rgba(0, 0, 0, 0.2);\n}\n.public-sessions tr:nth-child(odd) {\n\tbackground-color: rgba(255, 255, 255, 0.025);\n}\n\n.public-sessions tr:nth-child(even) {\n\tbackground-color: rgba(255, 255, 255, 0.05);\n}\n\n.public-sessions tr td.id {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmax-width: 11em;\n}\n\n.public-sessions tr td.desc {\n\twidth: 80%;\n\tword-break: break-all;\n}\n\n.public-sessions tr td:not(.desc) {\n\twhite-space: nowrap;\n\ttext-align: center;\n}\n\n.public-sessions th,\n.public-sessions td {\n\tpadding: 0.25em;\n}\n\n/* ** Help Modal ** */\n\n.faq p {\n\tmargin-left: 2em;\n}\n\n.help-options {\n\tdisplay: flex;\n}\n\n.help-options ul {\n\tlist-style-type: none;\n\tpadding-left: 1em;\n\tmargin-right: 1em;\n}\n\n.help-options ul li {\n\tpadding: 0.2em;\n\tpadding-left: 0.5em;\n}\n\n.help-options ul li:nth-child(even) {\n\tbackground: rgba(0, 0, 0, 0.12);\n}\n\n.help-options ul li:nth-child(odd) {\n\tbackground: rgba(255, 255, 255, 0.03);\n}\n\n.option-name {\n\tfont-variant: small-caps;\n}\n\n.container {\n\tmargin-top: 1em;\n}\n\n.disable-warning {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tz-index: 10;\n\ttransform: translate(-50%, -50%);\n\tfont-variant: small-caps;\n\twhite-space: nowrap;\n\tfont-size: 1em;\n\ttext-shadow: 0px 0px 10px black;\n}\n\n.controls-drafting-mask {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tpadding: 0 1em;\n\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr 1fr;\n\talign-items: center;\n\tbackground: linear-gradient(\n\t\tto left,\n\t\trgba(32, 32, 32, 1),\n\t\trgba(32, 32, 32, 0) 25%,\n\t\trgba(32, 32, 32, 1) 50%,\n\t\trgba(32, 32, 32, 0) 75%,\n\t\trgba(32, 32, 32, 1) 100%\n\t);\n}\n\n#url-remainder {\n\tfont-variant: small-caps;\n\tfont-weight: bold;\n\tfont-size: 1.5em;\n\tcolor: #888;\n}\n\n@media (max-width: 640px) {\n\t.controls-drafting-mask {\n\t\tgrid-template-columns: 1fr;\n\t\tgrid-template-rows: 1fr 1fr 1fr;\n\t}\n}\n\n#draft-in-progress {\n\twhite-space: nowrap;\n\tfont-variant: small-caps;\n\tfont-size: 1.5em;\n\ttext-align: center;\n}\n\n#draft-controls {\n\ttext-align: right;\n}\n\n.main-controls {\n\tbackground-color: #333;\n\tpadding: 0.2em 0.5em;\n}\n\n.main-controls input[type=\"checkbox\"] {\n\tmargin-right: 0;\n}\n\n.card-pool-controls .fas,\n#session-controls .far,\n#session-controls .fas {\n\tmargin-left: 1px;\n\tmargin-right: 1px;\n}\n\n#limited-controls,\n#view-controls {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n\talign-items: baseline;\n\tposition: relative;\n}\n\n#limited-controls > * {\n\tmargin-right: 4px;\n}\n\n#limited-controls > *:last-child {\n\tmargin-right: inherit;\n}\n\n#session-id {\n\twidth: 12em;\n}\n\n@media (max-width: 1400px) {\n\t#user-name,\n\t#session-id {\n\t\twidth: 10em;\n\t}\n}\n\n.inline-cube-name {\n\tdisplay: inline-block;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tmax-width: 16em;\n}\n\n@media (orientation: portrait) and (max-width: 500px) {\n\t#limited-controls,\n\t#view-controls {\n\t\tjustify-content: space-around;\n\t}\n\n\t#select-language-label {\n\t\tdisplay: none;\n\t}\n}\n\n.game-modes-cat {\n\tmargin-bottom: 0.5em;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.game-modes-cat button {\n\tdisplay: block;\n\twidth: calc(100% - 0.5em);\n\tbox-sizing: border-box;\n}\n\n.game-modes-cat-title {\n\ttext-align: center;\n\tfont-variant: small-caps;\n\tfont-size: 0.75em;\n}\n\n.setting-button {\n\tmargin: 0.5em;\n}\n\n/**** Session Players ****/\n\n.non-playing-session-owner-name {\n\tmax-width: 4em;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tmask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 90%, transparent);\n}\n\n.session-players {\n\tbackground: #181818;\n\tpadding: 0.25em 0.5em;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin: 0 0.5em;\n\tborder-radius: 0.5em;\n\tgap: 0.2em;\n}\n\n.session-players-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 0.2em;\n\tgrid-area: session-players-header;\n}\n\n.player-list-container {\n\tflex-grow: 2;\n\tpadding-left: 0.5em;\n\tpadding-right: 0.5em;\n\tgrid-area: player-list;\n}\n\nul.player-list {\n\tdisplay: inline-flex;\n\tlist-style: none;\n\twidth: 100%;\n\tpadding-left: 0;\n\tmargin: 0;\n\tflex-wrap: wrap;\n\tgap: 0.2em 0.8em;\n}\n\n.player-list li {\n\tposition: relative;\n\tdisplay: inline-flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 0.49em;\n\tmin-width: 6em;\n\tmax-width: 12em;\n\tbackground: #282828;\n\tborder-radius: 5px;\n\tflex: 1 1 6em;\n}\n\n.player-list li.self,\n.player-table li.self,\n.player-list-log li.self {\n\tbox-shadow: inset 0 0 5px 0px rgba(255, 255, 255, 0.3);\n}\n\n.current-player {\n\tbox-shadow: 0px 0px 10px 1px rgba(255, 255, 255, 0.5);\n}\n\n.player-list li.self.current-player,\n.player-table li.self.current-player,\n.player-list-log li.self.current-player {\n\tbox-shadow:\n\t\tinset 0 0 5px 0px rgba(255, 255, 255, 0.3),\n\t\t0px 0px 10px 1px rgba(255, 255, 255, 0.5);\n}\n\n.player-list li.draggable {\n\ttransform: translateY(0);\n}\n.player-list li.draggable:hover {\n\ttransform: translateY(-3px);\n\tbox-shadow: 3px 3px 5px 0 rgba(0, 0, 0, 0.75);\n}\n.player-list li.draggable.self:hover {\n\tbox-shadow:\n\t\tinset 0 0 5px 0px rgba(255, 255, 255, 0.3),\n\t\t3px 3px 5px 0 rgba(0, 0, 0, 0.75);\n}\n\n.player-list-transition-move,\n.player-list-transition-enter-active,\n.player-list-transition-leave-active {\n\ttransition: all 0.25s ease !important;\n}\n.player-list-transition-enter-from,\n.player-list-transition-leave-to {\n\topacity: 0;\n}\n\n.player-name {\n\tmin-width: 3em;\n\tflex: 1 1 3em;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tmask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 90%, transparent);\n}\n\n@media (max-width: 900px) {\n\t.session-players {\n\t\tdisplay: grid;\n\t\tgrid-template-areas:\n\t\t\t\"session-players-header chat\"\n\t\t\t\"player-list player-list\";\n\t\tgrid-template-columns: fit-content(30%);\n\t}\n\t.player-list li {\n\t\tflex: 1 1 20vw;\n\t\tmax-width: none;\n\t}\n}\n\n.move-player {\n\tcolor: #555;\n\t/*font-size: 0.8em;*/\n}\n\n.move-player-left {\n\tposition: absolute;\n\tleft: -0.3em;\n}\n\n.move-player-right {\n\tposition: absolute;\n\tright: -0.3em;\n}\n\n.status-icons {\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n\n.status-icons > * {\n\tmargin-left: 0.5em;\n\tfont-size: 14px;\n}\n\n.booster-count {\n\tposition: relative;\n\tmin-width: 14px;\n}\n.booster-count img {\n\twidth: 1em;\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform-origin: center bottom;\n\ttransform: translate(-50%, -50%);\n\tfilter: drop-shadow(0 0 2px #00000080);\n}\n.booster-count div {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tfont-weight: 900;\n\tcolor: black;\n\tfont-family: \"Brush Script MT\";\n}\n\n/* Booster passing animation */\n\n.booster-fade-in-enter-active,\n.slide-fade-right-enter-active,\n.slide-fade-right-leave-active,\n.slide-fade-left-enter-active,\n.slide-fade-left-leave-active {\n\tpointer-events: none; /* Avoid picking cards during transition */\n\ttransition: all 0.3s ease-in;\n}\n.slide-fade-left-enter-from,\n.slide-fade-right-leave-to {\n\ttransform: translateX(50px);\n\topacity: 0;\n}\n\n.slide-fade-right-enter-from,\n.slide-fade-left-leave-to {\n\ttransform: translateX(-50px);\n\topacity: 0;\n}\n\n.booster-fade-in-enter-from {\n\topacity: 0;\n}\n\n.booster-open-leave-active,\n.booster-cards-enter-active,\n.booster-cards-leave-active {\n\tpointer-events: none; /* Avoid picking cards during transition */\n\ttransition: all 0.5s;\n}\n\n.booster-cards-enter-from.wait {\n\topacity: 0;\n}\n\n.booster-open-leave-active.selected,\n.booster-cards-leave-active.selected {\n\ttransition: all 0.5s;\n\twidth: calc(var(--booster-card-scale) * 200px);\n\toverflow: visible;\n}\n\n.booster-open-leave-active.selected .card-image,\n.booster-cards-leave-active.selected .card-image {\n\twidth: calc(var(--booster-card-scale) * 200px);\n}\n\n.booster-open-leave-to.selected,\n.booster-cards-leave-to.selected {\n\ttransform: translateY(250px) translateX(calc(var(--booster-card-scale) * -100px)); /* translateX compensates for width change */\n\tz-index: 2;\n\topacity: 0;\n\twidth: 0;\n\tmargin: 0;\n}\n\n.booster-open-leave-active.burned,\n.booster-cards-leave-active.burned {\n\tanimation: card-burn 0.5s;\n}\n\n.booster-open-leave-to.burned,\n.booster-cards-leave-to.burned {\n\tmargin: 0;\n}\n\n@keyframes card-burn {\n\t0% {\n\t\ttransform: scale(1);\n\t\topacity: 1;\n\t}\n\t25% {\n\t\ttransform: scale(1.025);\n\t\topacity: 1;\n\t}\n\t50% {\n\t\ttransform: scale(1);\n\t\topacity: 1;\n\t}\n\t75% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\ttransform: scale(0);\n\t\topacity: 0;\n\t}\n}\n\n/**** Draft ****/\n\n.booster {\n\tposition: relative;\n\tmin-height: calc(var(--booster-card-scale) * 282px + 2 * 0.75em);\n}\n\n.booster-waiting .wait {\n\tposition: absolute;\n\tdisplay: flex;\n\tgap: 0.5em;\n\talign-items: center;\n\ttext-align: center;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translateX(-50%) translateY(-50%);\n\tz-index: 2;\n\tfont-size: 2.5em;\n\tline-height: 1.5em;\n\tfont-family: Calibri;\n\ttext-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n\tfont-weight: 600;\n\twhite-space: nowrap;\n}\n.booster-waiting .wait .passing-order {\n\tmargin: 0 2em;\n}\n.booster-waiting .wait .booster-wait-passing-order-right {\n\tanimation: passing-order-right 3s infinite;\n}\n.booster-waiting .wait .booster-wait-passing-order-left {\n\tanimation: passing-order-left 3s infinite;\n}\n\n@keyframes passing-order-right {\n\t0% {\n\t\ttransform: translateX(-2em);\n\t\topacity: 0;\n\t}\n\t25% {\n\t\ttransform: translateX(0);\n\t\topacity: 1;\n\t}\n\t75% {\n\t\ttransform: translateX(0);\n\t\topacity: 1;\n\t}\n\t100% {\n\t\ttransform: translateX(2em);\n\t\topacity: 0;\n\t}\n}\n\n@keyframes passing-order-left {\n\t0% {\n\t\ttransform: translateX(2em);\n\t\topacity: 0;\n\t}\n\t25% {\n\t\ttransform: translateX(0);\n\t\topacity: 1;\n\t}\n\t75% {\n\t\ttransform: translateX(0);\n\t\topacity: 1;\n\t}\n\t100% {\n\t\ttransform: translateX(-2em);\n\t\topacity: 0;\n\t}\n}\n\n.booster-waiting {\n\tpointer-events: none;\n\tbackground: repeating-linear-gradient(45deg, #282828, #282828 10px, #222 10px, #222 20px);\n}\n\n.booster-waiting .card {\n\tfilter: brightness(50%);\n}\n\n.skipped {\n\tfilter: grayscale();\n}\n\n#chrono,\n.chrono {\n\tpadding: 0.2em;\n\tpadding-left: 0.5em;\n\tpadding-right: 0.5em;\n\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmin-width: 2.6em;\n\twill-change: transform;\n}\n\n.section-title {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: 1em;\n\tmargin-right: 1em;\n\tmin-height: 35px;\n}\n.section-title h2 {\n\tdisplay: inline-block;\n\tmargin: 0;\n\tfont-variant: small-caps;\n\tfont-size: 28px;\n}\n\n@media (max-width: 700px) {\n\t.section-title {\n\t\tflex-wrap: wrap;\n\t}\n\n\t#booster-controls {\n\t\tflex-direction: column;\n\t}\n}\n\n.controls {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tgap: 0 1.5em;\n\tmargin-left: 1.5em;\n}\n@supports not (gap: 1.5em) {\n\t#main-container .controls > * {\n\t\tmargin-left: 1.5em;\n\t}\n}\n\n.card-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n\tbackground-color: #282828;\n\tborder-radius: 10px;\n\tbox-shadow: inset 0 0 8px #383838;\n\tpadding: 0.5em;\n}\n\n.deck-container {\n\tdisplay: flex;\n}\n\n.deck {\n\tflex: 1 1 auto;\n}\n\n.deck-stat-container {\n\tdisplay: flex;\n\tgap: 8px;\n}\n\n.deck-stat {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n.deck-stat img {\n\twidth: 16px;\n\theight: 16px;\n\tobject-fit: contain;\n\tmargin-left: 2px;\n\tfilter: brightness(0.5);\n}\n\n.deck-search input {\n\tmax-width: 8em;\n}\n\n.swap-controls {\n\tdisplay: flex;\n\tgap: 0.75em;\n}\n\n.collapsed-sideboard {\n\tflex: 0 0 auto;\n\tmargin-left: 1em;\n\tbox-sizing: border-box;\n}\n\n.collapsed-sideboard h2 {\n\tfont-size: 20px;\n\tline-height: 28px;\n}\n\n.selected.foil .inner-card-image, /* .foil .card-image has an 'overflow:hidden' preventing the box-shadow to show up. We'll apply it earlier in this case. */\n.selected .card-image .front-image,\n.selected .card-image .back-image,\n.selected .card-placeholder {\n\t--selected-card-shadow-color: rgb(3, 139, 6);\n\tbox-shadow: 0px 0px 4px 2px var(--selected-card-shadow-color);\n}\n\n.selected-high .card-image .front-image,\n.selected-high .card-image .back-image,\n.selected-high .card-placeholder {\n\tbox-shadow: 0px 0px 20px 4px rgba(0, 200, 2, 1);\n}\n\n.burned.foil .inner-card-image, /* .foil .card-image has an 'overflow:hidden' preventing the box-shadow to show up. We'll apply it earlier in this case. */\n\t.burned .card-image .front-image,\n\t.burned .card-image .back-image,\n\t.burned .card-placeholder {\n\tbox-shadow: 0px 0px 12px 4px rgb(161, 0, 3);\n}\n\n.card:hover {\n\tz-index: 10;\n}\n\n.card-column {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-bottom: 0.5em;\n\tmin-height: 300px;\n}\n.card-column > .column-card-container,\n.card-column > .column-card-container > .card,\n.card-column > .card {\n\theight: 0;\n\tpadding-bottom: calc(\n\t\tvar(--card-title-height-factor, 1) * 13.5%\n\t); /* As a percentage of the container width, used to display card name (instead of setting a height), makes its 'responsive' */\n\tmargin: 0;\n\tz-index: 0;\n}\n\n/* Bug in webkit applies with style to another element while drag & dropping https://bugs.webkit.org/show_bug.cgi?id=134555 */\n.card-column > .column-card-container:hover,\n.card-column > .card:hover {\n\tz-index: 800; /* NOTE: This forces the browser to relayout and is very slow in large lists (especially on Chrome). A solution could be to render a copy instead of bringing it forward, but it's more complicated. */\n}\n\n.card-column > .column-card-container:last-child,\n.card-column > .column-card-container:last-child > .card,\n.card-column > .card:last-child {\n\tmargin-bottom: calc(142.5% - var(--card-title-height-factor, 1) * 13.5%);\n}\n\n/* Only use this hover rule on desktop (hover capabilities and a mouse or equivalent device) */\n@media (hover: hover) and (pointer: fine) {\n\t/* No :hover outside of the div bounds, will let the card disappear when the mouse moves outside of it */\n\t.card-column > .column-card-container > .card > div, /* This version doesn't ~always~ work as expected on Chrome (Sometimes it just fixes itself...), but does in Firefox  */\n\t.card-column > .card > div {\n\t\tpointer-events: none;\n\t}\n\t/* Except if its fully visible */\n\t.card-column > .column-card-container:last-child > .card > div,\n\t.card-column > .card:last-child > div {\n\t\tpointer-events: auto;\n\t}\n}\n\n.drag-column {\n\tmin-width: 200px;\n\tbackground-color: rgba(0, 0, 0, 0.1);\n\tborder-radius: 6px;\n\n\ttransition:\n\t\tbox-shadow 0.1s ease-in-out,\n\t\tbackground-color 0.1s ease-in-out;\n}\n\n.drag-column[drop-active=\"true\"] {\n\t/*box-shadow: -7px 0 5px -5px white, 7px 0 5px -5px white;*/\n\tbox-shadow: 0 0 4px 3px white;\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n/* :has isn't supported on Firefox yet, causing the whole rule to be ignored. This is duplicated on purpose. */\n.drag-column:has(.ghost),\n.drag-column[drop-active=\"true\"] {\n\tbox-shadow: 0 0 4px 3px white;\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n\n/**** Draft Spectator ****/\n\n.draft-watching-state {\n\ttext-align: center;\n\n\tdiv {\n\t\tmargin-bottom: 1em;\n\t}\n}\n\n.loading {\n\tposition: fixed;\n\tz-index: 999;\n\theight: 2em;\n\twidth: 2em;\n\toverflow: visible;\n\tmargin: auto;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n}\n\n/* Transparent Overlay */\n.loading:before {\n\tcontent: \"\";\n\tdisplay: block;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: rgba(0, 0, 0, 0.8);\n}\n\n.loading + span {\n\tposition: fixed;\n\ttop: calc(50vh + 2em);\n\tright: 0;\n\tleft: 0;\n\tz-index: 1000;\n\ttext-align: center;\n}\n\n/* :not(:required) hides these rules from IE9 and below */\n.loading:not(:required) {\n\t/* hide \"loading...\" text */\n\tfont: 0/0 a;\n\tcolor: transparent;\n\ttext-shadow: none;\n\tbackground-color: transparent;\n\tborder: 0;\n}\n\n.loading:not(:required):after {\n\t--spinner-color: rgba(255, 255, 255, 0.75);\n\tcontent: \"\";\n\tdisplay: block;\n\tfont-size: 10px;\n\twidth: 1em;\n\theight: 1em;\n\tmargin-top: -0.5em;\n\t-webkit-animation: spinner 1500ms infinite linear;\n\t-moz-animation: spinner 1500ms infinite linear;\n\t-ms-animation: spinner 1500ms infinite linear;\n\t-o-animation: spinner 1500ms infinite linear;\n\tanimation: spinner 1500ms infinite linear;\n\tborder-radius: 0.5em;\n\t-webkit-box-shadow:\n\t\tvar(--spinner-color) 1.5em 0 0 0,\n\t\tvar(--spinner-color) 1.1em 1.1em 0 0,\n\t\tvar(--spinner-color) 0 1.5em 0 0,\n\t\tvar(--spinner-color) -1.1em 1.1em 0 0,\n\t\trgba(0, 0, 0, 0.5) -1.5em 0 0 0,\n\t\trgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0,\n\t\tvar(--spinner-color) 0 -1.5em 0 0,\n\t\tvar(--spinner-color) 1.1em -1.1em 0 0;\n\tbox-shadow:\n\t\tvar(--spinner-color) 1.5em 0 0 0,\n\t\tvar(--spinner-color) 1.1em 1.1em 0 0,\n\t\tvar(--spinner-color) 0 1.5em 0 0,\n\t\tvar(--spinner-color) -1.1em 1.1em 0 0,\n\t\tvar(--spinner-color) -1.5em 0 0 0,\n\t\tvar(--spinner-color) -1.1em -1.1em 0 0,\n\t\tvar(--spinner-color) 0 -1.5em 0 0,\n\t\tvar(--spinner-color) 1.1em -1.1em 0 0;\n}\n\n@keyframes spinner {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.shaking {\n\tanimation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n\ttransform: translate3d(0, 0, 0);\n\tbackface-visibility: hidden;\n\tperspective: 1000px;\n}\n\n@keyframes shake {\n\t10%,\n\t90% {\n\t\ttransform: translate3d(-1px, 0, 0);\n\t}\n\n\t20%,\n\t80% {\n\t\ttransform: translate3d(2px, 0, 0);\n\t}\n\n\t30%,\n\t50%,\n\t70% {\n\t\ttransform: translate3d(-4px, 0, 0);\n\t}\n\n\t40%,\n\t60% {\n\t\ttransform: translate3d(4px, 0, 0);\n\t}\n}\n\n.pulsing {\n\tanimation: pulse 0.4s;\n\tbox-shadow: 0 0 0 0 rgba(200, 0, 0, 1);\n\ttransform: scale(1);\n}\n\n@keyframes pulse {\n\t0% {\n\t\ttransform: scale(1.1);\n\t\tbox-shadow: 0 0 0 0 rgba(200, 0, 0, 0.7);\n\t}\n\n\t70% {\n\t\ttransform: scale(1);\n\t\tbox-shadow: 0 0 0 10px rgba(200, 0, 0, 0);\n\t}\n\n\t100% {\n\t\ttransform: scale(1);\n\t\tbox-shadow: 0 0 0 0 rgba(200, 0, 0, 0);\n\t}\n}\n\n.rochester-container {\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n/*\nCan't be applied to .card-filtered directly as it creates a bug with the rotation handle position.\nSee: https://stackoverflow.com/questions/52937708/why-does-applying-a-css-filter-on-the-parent-break-the-child-positioning\n*/\n.card-filtered .card-image img {\n\tfilter: brightness(35%) saturate(50%);\n}\n\n.card-image img {\n\ttransition: filter 0.2s;\n}\n\n.fixed-deck-and-sideboard-container {\n\tbox-sizing: border-box;\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\theight: 400px;\n\tmargin: 0px;\n\tbackground-color: rgb(32, 32, 32);\n\tz-index: 800;\n\tbox-shadow: 0 -4px 5px #000;\n}\n\n.deck-and-sideboard-container-resize-bar {\n\tposition: absolute;\n\ttop: -1px;\n\tleft: 0;\n\tright: 0;\n\theight: 2px;\n\tbackground-color: #888;\n\tborder-top: 1px solid #bbb;\n\tborder-bottom: 1px solid #222;\n\tcursor: ns-resize;\n\tz-index: 801;\n}\n\n.fixed-deck-and-sideboard-close {\n\tposition: absolute;\n\ttop: 6px;\n\tright: 6px;\n}\n\n.fixed-deck-and-sideboard-container .deck-and-sideboard {\n\tbox-sizing: border-box;\n\tposition: relative;\n\toverflow: auto;\n\tpadding: 1em;\n\tpadding-top: 0;\n\tmax-height: 100%;\n}\n\n.fixed-deck-and-sideboard-container .deck-container {\n\tmargin-top: 0.25em;\n}\n\n.v-popper__popper {\n\tpointer-events: none;\n}\n\n.v-popper--theme-dropdown .v-popper__inner {\n\tbackground: #404040;\n\tcolor: #ddd;\n\tborder-color: #606060;\n}\n\n.v-popper--theme-dropdown .v-popper__arrow-inner {\n\tborder-color: #404040;\n}\n\n.v-popper--theme-dropdown.v-popper__popper {\n\tz-index: 1010;\n}\n\n.timer-icon {\n\t--timer-max: 75;\n\t--timer-current: 75;\n\tposition: relative;\n}\n\n.timer-icon-moving {\n\tposition: absolute;\n\tbottom: 6.6px;\n\tleft: calc(50% - 1px);\n\twidth: 2px;\n\theight: 7px;\n\tbackground-color: #222;\n\tborder-radius: 10px;\n\n\twill-change: transform;\n\ttransform-origin: 50% calc(100% - 1px);\n\ttransition: transform 1s linear;\n\ttransform: rotate(calc(-360deg * min(var(--timer-max), var(--timer-current)) / var(--timer-max)));\n}\n\n.multi-drag-selected::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: -10%;\n\tleft: -1.5%;\n\tright: -1.5%;\n\tbottom: -20%;\n\tborder-radius: 3.5%/28% 28% 24% 24%;\n\tbackground-color: #518ae6d0;\n}\n\n/* Temp Draft Queue Banner */\n.draft-queue-banner {\n\tposition: relative;\n\tmax-width: min(500px, 90wv);\n}\n\n.draft-queue-banner img {\n\tborder-radius: 12px;\n\tbox-shadow:\n\t\t0 4px 8px 0 rgba(0, 0, 0, 0.2),\n\t\t0 6px 20px 0 rgba(0, 0, 0, 0.19);\n\tmax-width: 100%;\n\theight: auto;\n\ttransition: all 0.2s;\n}\n\n.draft-queue-banner:hover img {\n\tbox-shadow:\n\t\t0 0 4px 0px rgba(255, 255, 255, 0.8),\n\t\t0 0 20px 0px #72a7ff,\n\t\t0 4px 8px 0 rgba(0, 0, 0, 0.2),\n\t\t0 6px 20px 0 rgba(0, 0, 0, 0.19);\n\tfilter: saturate(1.2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
